import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-funimation', 'IconBrandFunimation', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M8 13h8a4 4 0 1 1 -8 0z', key: 'svg-1' }],
]);
